import * as PropTypes from 'prop-types';

interface RoleIndicatorProps {
  onChange: any;
  placeholder: string;
}

const SearchField: React.FC<RoleIndicatorProps> = (props) => {
  return (
    <div className="d-flex align-items-center position-relative my-1">
      <i className=" svg-icon svg-icon-3 position-absolute ms-3 fa-duotone fa-magnifying-glass"></i>
      <input
        type="text"
        className="form-control form-control-solid form-select-sm w-150px ps-9"
        {...props}
      />
    </div>
  );
};

export default SearchField;
SearchField.propTypes = {
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired
};
